import type { FC } from 'react';
import React from 'react';

interface Props {
  className?: string;
}

const Spinner: FC<Props> = ({ className }) => (
  <div className="flex">
    <svg
      className={`animate-spin ${className || ''}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="10" opacity="1" stroke="#7545FB" strokeWidth="4" />
      <path
        opacity="0.7"
        fill="#330F3F"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  </div>
);

export default Spinner;
